// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TextToImageNode 样式 */
.TextToImageNode-wrapper {
  width: 320px;
}

.TextToImageNode-field {
  margin-bottom: 12px;
}

.TextToImageNode-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.TextToImageNode-button-group {
  display: flex;
  gap: 8px;
}

.TextToImageNode-button {
  flex: 1;
  padding: 8px;
  background: white;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.TextToImageNode-button-active {
  background: #667eea;
  color: white;
}

.TextToImageNode-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background: white;
}

.TextToImageNode-hint {
  margin-bottom: 12px;
  padding: 10px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  font-size: 12px;
  color: #1e40af;
  line-height: 1.5;
}

.TextToImageNode-generate {
  width: 100%;
  padding: 12px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s;
}

.TextToImageNode-generate:hover {
  background: #2563eb;
}

.TextToImageNode-generate-disabled {
  background: #ccc;
  cursor: not-allowed;
}

.TextToImageNode-status {
  margin-top: 12px;
  padding: 8px;
  background: #e0f2fe;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  font-size: 12px;
  color: #0c4a6e;
  text-align: center;
  font-weight: 500;
}

.TextToImageNode-results {
  margin-top: 12px;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.TextToImageNode-results-title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.TextToImageNode-images {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.TextToImageNode-image-item {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: white;
}

.TextToImageNode-image {
  width: 100%;
  display: block;
}

.TextToImageNode-image-info {
  padding: 6px 8px;
  background: rgba(0, 0, 0, 0.05);
  font-size: 11px;
  color: #666;
  text-align: center;
}

.TextToImageNode-error {
  margin-top: 12px;
  padding: 8px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  font-size: 12px;
  color: #c33;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/TextToImageNode.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb","sourcesContent":["/* TextToImageNode 样式 */\n.TextToImageNode-wrapper {\n  width: 320px;\n}\n\n.TextToImageNode-field {\n  margin-bottom: 12px;\n}\n\n.TextToImageNode-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 6px;\n}\n\n.TextToImageNode-button-group {\n  display: flex;\n  gap: 8px;\n}\n\n.TextToImageNode-button {\n  flex: 1;\n  padding: 8px;\n  background: white;\n  color: #333;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.TextToImageNode-button-active {\n  background: #667eea;\n  color: white;\n}\n\n.TextToImageNode-select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background: white;\n}\n\n.TextToImageNode-hint {\n  margin-bottom: 12px;\n  padding: 10px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #1e40af;\n  line-height: 1.5;\n}\n\n.TextToImageNode-generate {\n  width: 100%;\n  padding: 12px;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background 0.2s;\n}\n\n.TextToImageNode-generate:hover {\n  background: #2563eb;\n}\n\n.TextToImageNode-generate-disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.TextToImageNode-status {\n  margin-top: 12px;\n  padding: 8px;\n  background: #e0f2fe;\n  border: 1px solid #bae6fd;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #0c4a6e;\n  text-align: center;\n  font-weight: 500;\n}\n\n.TextToImageNode-results {\n  margin-top: 12px;\n  padding: 12px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.TextToImageNode-results-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.TextToImageNode-images {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.TextToImageNode-image-item {\n  position: relative;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  background: white;\n}\n\n.TextToImageNode-image {\n  width: 100%;\n  display: block;\n}\n\n.TextToImageNode-image-info {\n  padding: 6px 8px;\n  background: rgba(0, 0, 0, 0.05);\n  font-size: 11px;\n  color: #666;\n  text-align: center;\n}\n\n.TextToImageNode-error {\n  margin-top: 12px;\n  padding: 8px;\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #c33;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
